(function() {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function addBusinessDays(startDate, days) {
    let currentDate = new Date(startDate);
    let addedDays = 0;
    
    while (addedDays < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay();
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }
    
    return currentDate;
  }

  function formatDate(date) {
    const dayName = dayNames[date.getDay()];
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    return `${dayName} ${day} ${month}`;
  }

  function calculateDeliveryDates() {
    const today = new Date();
    const dateElements = document.querySelectorAll('.estimated-delivery__dates[data-min-days][data-max-days]');
    
    dateElements.forEach(function(element) {
      const minDays = parseInt(element.getAttribute('data-min-days'), 10);
      const maxDays = parseInt(element.getAttribute('data-max-days'), 10);
      
      if (!isNaN(minDays) && !isNaN(maxDays) && minDays > 0 && maxDays > 0) {
        const minDate = addBusinessDays(today, minDays);
        const maxDate = addBusinessDays(today, maxDays);
        
        element.textContent = `${formatDate(minDate)} - ${formatDate(maxDate)}`;
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calculateDeliveryDates);
  } else {
    calculateDeliveryDates();
  }
})();
